<template>
  <v-dialog
    v-model="open"
    persistent
    max-width="500px"
    scrollable
    content-class="tw-rounded-3xl"
  >
    <v-form
      ref="form_messages_videocall"
      v-model="valid"
      :disabled="form_loading"
      lazy-validation
      enctype="multipart/form-data"
      @submit.prevent="onSubmit"
    >
      <v-card class="tw-rounded-3xl tw-border-0 tw-shadow-md">
        <ModalHeader @close-modal="closeModal">Messages Videocall</ModalHeader>
        <v-card-text>
          <h2 class="tw-title-font tw-mb-4 tw-text-md tw-font-medium">
            Usar etiqueta <b>:name</b> para manejar el nombre del usuario
          </h2>
          <div class="tw-grid tw-gap-4">
            <v-text-field
              v-model="messages_videocall.busy"
              outlined
              rounded
              dense
              label="Busy"
              hide-details
            />
            <!--<v-text-field-->
            <!--  v-model="messages_videocall.calling"-->
            <!--  outlined-->
            <!--  rounded-->
            <!--  dense-->
            <!--  label="Calling"-->
            <!--  hide-details-->
            <!--/>-->
            <!--<v-text-field-->
            <!--  v-model="messages_videocall.missed"-->
            <!--  outlined-->
            <!--  rounded-->
            <!--  dense-->
            <!--  label="Missed"-->
            <!--  hide-details-->
            <!--/>-->
            <v-text-field
              v-model="messages_videocall.declined"
              outlined
              rounded
              dense
              label="Declined"
              hide-details
            />
            <v-text-field
              v-model="messages_videocall.hung_up"
              outlined
              rounded
              dense
              label="Hung Up"
              hide-details
            />
            <v-text-field
              v-model="messages_videocall.waiting"
              outlined
              rounded
              dense
              label="Waiting"
              hide-details
            />
            <v-text-field
              v-model="messages_videocall.ringing"
              outlined
              rounded
              dense
              label="Ring ing"
              hide-details
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="blue darken-1"
            text
            rounded
            :disabled="form_loading"
            class="tw-px-8 tw-normal-case focus:tw-outline-none focus:tw-ring focus:tw-ring-white"
            @click="open = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary darken-1"
            rounded
            type="submit"
            :loading="form_loading"
            class="text--white text--lighten-4 tw-px-8 tw-normal-case focus:tw-outline-none focus:tw-ring focus:tw-ring-primary-300"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import ModalHeader from '@/components/ModalHeader'

export default {
  components: {
    ModalHeader,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    messages: {
      type: [Array, Object],
      default: () => ({}),
    },
  },
  data: () => ({
    form_loading: false,
    valid: true,
  }),
  computed: {
    messages_videocall: {
      get() {
        return this.messages
      },
      set(newValue) {
        this.$emit('update:messages', newValue)
      },
    },
    open: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    onSubmit() {
      this.open = false
    },
    closeModal() {
      this.open = false
    },
  },
}
</script>
